/* Ported from ac-cat-v2 assets/pdp-kit.js. */
/* Atlas bundle PDP "What's inside": tab / prev / next (desktop, with swipe) and mobile card progress. */
(function () {
  function init(sec) {
    if (sec.__pdpKit) return;
    sec.__pdpKit = true;
    const n = parseInt(sec.dataset.count, 10) || 0;
    const pad = (v) => String(v).padStart(2, '0');
    const tabs = [...sec.querySelectorAll('[data-kit-tab]')];
    const panels = [...sec.querySelectorAll('[data-kit-panel]')];
    let k = 0;

    function show(i) {
      k = ((i % n) + n) % n;
      tabs.forEach((t, j) => { t.classList.toggle('is-on', j === k); t.setAttribute('aria-selected', j === k ? 'true' : 'false'); });
      panels.forEach((p, j) => { p.hidden = j !== k; });
      const idx = panels[k] && panels[k].querySelector('[data-kit-idx]');
      if (idx) idx.textContent = pad(k + 1) + ' / ' + pad(n);
    }
    tabs.forEach((t, j) => t.addEventListener('click', () => show(j)));
    sec.querySelectorAll('[data-kit-prev]').forEach((b) => b.addEventListener('click', () => show(k - 1)));
    sec.querySelectorAll('[data-kit-next]').forEach((b) => b.addEventListener('click', () => show(k + 1)));

    // swipe (desktop layout only, mobile has its own scroller)
    let kx = null, ky = null;
    sec.addEventListener('touchstart', (e) => {
      if (window.innerWidth < 900) return;
      kx = e.touches[0].clientX; ky = e.touches[0].clientY;
    }, { passive: true });
    sec.addEventListener('touchend', (e) => {
      if (kx == null) return;
      const dx = e.changedTouches[0].clientX - kx, dy = e.changedTouches[0].clientY - ky;
      kx = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(k + (dx < 0 ? 1 : -1));
    });

    // mobile scroller
    const sc = sec.querySelector('[data-kit-scroll]');
    const segs = [...sec.querySelectorAll('[data-kit-segs] span')];
    const midx = sec.querySelector('[data-kit-midx]');
    if (sc) {
      sc.addEventListener('scroll', () => {
        const c = sc.firstElementChild;
        if (!c) return;
        const i = Math.min(n - 1, Math.round(sc.scrollLeft / (c.getBoundingClientRect().width + 10)));
        segs.forEach((s, j) => s.classList.toggle('is-on', j === i));
        if (midx) midx.textContent = pad(i + 1) + ' / ' + pad(n);
      }, { passive: true });
    }
  }
  function boot() { document.querySelectorAll('[data-pdp-kit]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
